import { getConfidenceClass } from "../../Document/getConfidenceClass";
import { State } from "../../types";

export type RemoveAnswerAction = Readonly<{
  key: string;
  type: "REMOVE ANSWER";
}>;

export const removeAnswer = (state: State, action: RemoveAnswerAction): State => {
  if (!(action.key in state.values)) {
    return state;
  }
  const keyComps = action.key.split('.');
  let prefix = action.key.substring(0, action.key.lastIndexOf('.')) + ".";
  let index = +keyComps[keyComps.length-1];

  const siblingKeys = Object.keys(state.values).filter(sibling => {
    return sibling.startsWith(prefix);
  });
  siblingKeys.sort();

  const values = { ...state.values };

  let blocks = state.blocks;

  // remove references to the block we're deleting
  const idRef = state.values[action.key].idRef;
  if (idRef && idRef in state.blocks) {
    let newBlock= {
      ...state.blocks[idRef],
      references: state.blocks[idRef].references.filter(r => r !== action.key),
    };
    blocks = {
      ...blocks,
      [idRef]: {
        ...newBlock,
        confidenceClass: getConfidenceClass(newBlock, state.confidenceThreshold, values),
      },
    };
  }
  
  // Shift all future values down by 1
  for (let i = index; i < siblingKeys.length; i++) {
    let currentKey = prefix +  i
    let nextKey = prefix + (i + 1);
    let nextNode = {...values[nextKey]};
    nextNode.valueKey = currentKey;
    values[currentKey] = nextNode

    const idRef = nextNode.idRef;
    if (idRef && idRef in state.blocks) {

      // shift reference from the next value down by 1
      let newBlock = {
          ...state.blocks[idRef],
          references: state.blocks[idRef].references.map(r => {
            return r === nextKey ? currentKey : r
          }),
      };
  
      blocks = {
        ...blocks,
        [idRef]: {
          ...newBlock,
          confidenceClass: getConfidenceClass(newBlock, state.confidenceThreshold, values),
        },
      };
    }
  }

  const blockToDelete = prefix + (siblingKeys.length);
  delete values[blockToDelete];
  
  let activeValue = state.activeValue;
  if (!(activeValue in values)) {
    activeValue = "";
  }
  return {
    ...state,
    activeValue,
    blocks,
    modified: true,
    values,
  };
};
